import { render, staticRenderFns } from "./VitalsignTab.vue?vue&type=template&id=35756f92&"
import script from "./VitalsignTab.vue?vue&type=script&lang=ts&"
export * from "./VitalsignTab.vue?vue&type=script&lang=ts&"
import style0 from "./VitalsignTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports